import { createFeatureSelector, createSelector } from '@ngrx/store';
const getAuditLog = createFeatureSelector<any>('auditlog');

/**
 * Audit Log operation
 */

export const getAuditLogOperations = createSelector(
  getAuditLog,
  (state: any) => state.operations
);

export const getNotificationLogDetails = createSelector(
  getAuditLog,
  (state:any) => state.notificationLogDetail
)
